import AddIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Divider,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import SkillDetails from "./SkillDetails";
const SkillsView = ({
  selectedSkillData,
  skillList,
  handleSkillClick,
  handleDeleteClick,
  enableSave,
  oneOffList,
  handleOneOfChange,
  handleSaveAPI,
}) => {
  const theme = useTheme();
  const [searchTerm, setSearchTerm] = useState("");
  const filteredSkills = skillList.filter((skill) =>
    skill.COURSE_ID.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <Box sx={{ display: "flex" }}>
      <Box sx={{ width: "30%" }}>
        <TextField
          // variant="outlined"
          size="small"
          margin="normal"
          fullWidth
          id="search"
          sx={{ ml: 1 }}
          label="Search Courses"
          name="search"
          autoComplete="off"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <List sx={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
          {filteredSkills.map((item) => {
            const { COURSE_ID, COURSE_NAME } = item;

            return (
              <div key={COURSE_ID}>
                <ListItem
                  button
                  title={COURSE_NAME}
                  // selected={selectedSkill === skillId}
                  onClick={() => handleSkillClick(item)}
                  sx={{
                    overflow: "hidden",
                    scrollbarWidth: "none",
                    "&.Mui-selected": {
                      borderLeft: `4px solid ${theme.palette.primary.main}`,
                    },
                  }}
                >
                  <ListItemIcon>
                    <AddIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <>
                        <Box>{COURSE_ID}</Box>
                        <Box>{COURSE_NAME}</Box>
                      </>
                    }
                    sx={{
                      ml: -2,
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      scrollbarWidth: "none",
                    }}
                  />
                </ListItem>
                <Divider />
              </div>
            );
          })}
        </List>
      </Box>
      <Box sx={{ width: "70%" }}>
        <SkillDetails
          courses={selectedSkillData}
          handleDeleteClick={handleDeleteClick}
          enableSave={enableSave}
          oneOffList={oneOffList}
          handleOneOfChange={handleOneOfChange}
          handleSaveAPI={handleSaveAPI}
        />
      </Box>
    </Box>
  );
};

export default SkillsView;
